import { useContext } from "react";
import { AuthContext } from "../auth-context";
import IODate from "../widget/io-date";
import IOList from "../widget/io-list";
import IOPanelWithNavigation from "../widget/io-panel-with-navigation";
import IOText from "../widget/io-text";
import Panel from "../widget/panel";
import TwoColumns from "../widget/two-columns";
import type { Appointment, Patient } from "./_objects-patient";
import { type RelatedElementGeneratorProps } from "./patient-related-element-generator";

export default function AppointmentElement(
  props: { patient: Patient } & RelatedElementGeneratorProps<Appointment>
): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;

  return (
    <IOPanelWithNavigation<Appointment>
      {...props}
      key={`appointment.${props.file.id}`}
      type="appointment"
      apiRootUrl={`/api/patient/${props.patient.id}/appointment`}
      restrictedForWrite="write"
      restrictedForUnlock="manage_archives"
      basePath={`${props.parentPath}/appointment`}
      header={<span>{props.file.center}</span>}
    >
      <TwoColumns>
        <Panel fixed label="Information">
          <input
            type="hidden"
            name="patient_id"
            defaultValue={props.patient.id}
          />
          <IODate name="date" value={props.file.date} required />
          <IOList
            name="center"
            value={props.file.center}
            list={authenticationContext!.getList("Centers")}
          />
        </Panel>
        <Panel fixed label="Objective">
          <IOText name="purpose" value={props.file.purpose} />
        </Panel>
      </TwoColumns>
    </IOPanelWithNavigation>
  );
}
